import { ThunkAction } from 'redux-thunk'
import { ActionType, createStandardAction, getType } from 'typesafe-actions'

// @ts-ignore
import { actions as apiActions } from '../api'
// @ts-ignore
import { getJsonApiClient, setEntityModel } from '../api/apiClient'
// @ts-ignore
import apiRequest from '../api/request'
import { actionCreators as loginActionCreators, LoginActions } from '../login'
import { INCLUDE_ENTITY as INCLUDE_ENTITY_LSP } from '../lsps'
import { Entity } from 'types/Entity'
import { ErrorResponse, OneToOneRelationship } from 'types/JsonApi'
import { MeWithIncludes, MeAsApiResponse, Me } from 'types/Me'
import { LSP } from 'types/LSP'

// Types
export interface State extends Me {
  lsp: LSP | OneToOneRelationship
  isFetching: boolean
  hasFetched: boolean
}

// Constants
export const ENTITY: Entity = 'me'

// Model and initial state
export const Model: MeWithIncludes = {
  email: '',
  first_name: '',
  id: '',
  last_name: '',
  title: 'unknown',
  legacy_id: 0,
  lsp: {
    jsonApi: 'hasOne',
    type: INCLUDE_ENTITY_LSP
  },
  mobile: '',
  roles: [],
  state: 'live'
}
export const initialState: State = {
  ...Model,
  isFetching: false,
  hasFetched: false
}

// Action creators
const actionCreatorsSync = {
  loadMeRequest: createStandardAction('LOAD_ME_REQUEST').map(() => ({
    payload: {},
    meta: {},
    error: false
  })),
  loadMeSuccess: createStandardAction('LOAD_ME_ITEM_SUCCESS').map(
    ({ result: payload }: { result: MeAsApiResponse }) => ({
      payload,
      meta: {},
      error: false
    })
  ),
  loadMeFailure: createStandardAction('LOAD_ME_ITEM_FAILURE').map(
    ({ errors: payload }: ErrorResponse) => ({
      payload,
      meta: {},
      error: true
    })
  )
}
export type MeActions = ActionType<typeof actionCreatorsSync>
type ThunkResult<R> = ThunkAction<R, { me: State }, unknown, MeActions>
export const actionCreatorsAsync = {
  loadMe: (): ThunkResult<void> => dispatch => {
    return apiRequest({
      apiAction: 'get',
      apiOptions: {
        include: INCLUDE_ENTITY_LSP
      },
      apiUrl: getJsonApiClient().all(ENTITY),
      dispatch,
      entityName: ENTITY
    })
  }
}
export const actionCreators = { ...actionCreatorsSync, ...actionCreatorsAsync }

// Reducer
export default function reducer (
  state: typeof initialState = initialState,
  action: MeActions | LoginActions
) {
  switch (action.type) {
    case getType(actionCreators.loadMeRequest):
      return {
        ...state,
        isFetching: true
      }
    case getType(actionCreators.loadMeSuccess):
      return {
        ...state,
        hasFetched: true,
        isFetching: false,
        ...action.payload
      }
    case getType(actionCreators.loadMeFailure):
      return {
        ...state,
        hasFetched: true,
        isFetching: false
      }
    case getType(loginActionCreators.logoutAction):
    case getType(loginActionCreators.sessionExpiredAction):
      return {
        ...initialState
      }
    default:
      return state
  }
}

// Side effects
setEntityModel(ENTITY, Model, {
  collectionPath: 'me'
})
